import Component from './component';
import transform from './transformer';

const Calculators = (props) => <Component {...transform(props)} />;

export default Calculators;

export { Component as component, transform as transformer };
